module.exports = __webpack_public_path__ + "img/commodity-003.9857149e.png";